import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import { handleSpringDataMutationRequest } from "../../../../api";

export default function CancelBooking({
  bookingId,
  setOpenCancelBookingModal,
  hotelId,
  fetchBookingData,
  onClose,
}) {
  const [cancelBookingLoader, setCancelBookingLoader] = useState(false);
  const handleCancelBooking = () => {
    setCancelBookingLoader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/cancel-booking`,
      {
        hotelId: hotelId,
        bookingId: bookingId,
      }
    )
      .then(() => {
        fetchBookingData();
        setCancelBookingLoader(false);
        setOpenCancelBookingModal(false);
        onClose();
      })
      .catch(() => {
        onClose();
        setOpenCancelBookingModal(false);
        setCancelBookingLoader(false);
      });
  };
  return (
    <Box>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Do you want to cancel the booking id {bookingId} ?
      </Typography>
      <Box sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="custom-button"
          onClick={handleCancelBooking}
          disabled={cancelBookingLoader}
        >
          Yes{" "}
          {cancelBookingLoader && (
            <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
          )}
        </Button>
        <Button
          variant="outlined"
          onClick={() => setOpenCancelBookingModal(false)}
          sx={{ textTransform: "none" }}
        >
          No
        </Button>
      </Box>
    </Box>
  );
}
